__turbopack_context__.v({
  "ariaSlider": "PlasmicSlider-module__0Hpeoa__ariaSlider",
  "ariaSliderOutput": "PlasmicSlider-module__0Hpeoa__ariaSliderOutput",
  "ariaSliderTrack": "PlasmicSlider-module__0Hpeoa__ariaSliderTrack",
  "background": "PlasmicSlider-module__0Hpeoa__background",
  "description": "PlasmicSlider-module__0Hpeoa__description",
  "foreground": "PlasmicSlider-module__0Hpeoa__foreground",
  "freeBox__jyqRc": "PlasmicSlider-module__0Hpeoa__freeBox__jyqRc",
  "freeBox__vft0H": "PlasmicSlider-module__0Hpeoa__freeBox__vft0H",
  "sliderThumb__hDvt8": "PlasmicSlider-module__0Hpeoa__sliderThumb__hDvt8",
  "text___0Db09": "PlasmicSlider-module__0Hpeoa__text___0Db09",
  "text__hP1PL": "PlasmicSlider-module__0Hpeoa__text__hP1PL",
  "text__j2Mdj": "PlasmicSlider-module__0Hpeoa__text__j2Mdj",
});
